/* eslint-disable import/prefer-default-export */
import { freightZoneLevel } from 'pando-constants';

// name of the constant = route name in lower case
const bfr = [
  {
    title: 'Source',
    column: 'source',
    tlabel: 'MDM_SOURCE',
    truncateOn: 20,
    show: true,
    colSpan: 2,
  },
  {
    title: 'SOURCE TYPE',
    column: 'source_type',
    tlabel: 'MDM_SOURCE_TYPE',
    truncateOn: 20,
    show: true,
    colSpan: 2,
  },
  {
    title: 'CITY REF',
    column: 'city_ref',
    tlabel: 'MDM_CITY_REF',
    show: true,
    colSpan: 3,
  },
  {
    title: 'Transporter',
    column: 'transporter_name',
    tlabel: 'MDM_TRANSPORTER',
    truncateOn: 20,
    show: true,
    colSpan: 2,
  },
  {
    title: 'CURRENT BFR',
    column: 'bdrAmount',
    tlabel: 'MDM_CURRENT_BDR',
    show: true,
    colSpan: 2,
  },
  {
    title: 'Min BDR Threshold',
    column: 'minBdrThreshold',
    tlabel: 'MDM_MIN_BDR_THRESHOLD',
    show: true,
    colSpan: 3,
  },
  {
    title: 'Max BDR Factor',
    column: 'maxBdrFactor',
    tlabel: 'MDM_MAX_BDR_FACTOR',
    show: true,
    colSpan: 3,
  },
  {
    title: 'Rate Factor',
    column: 'dieselComponentFactor',
    tlabel: 'MDM_DIESEL_COMPONENT_FACTOR',
    show: true,
    colSpan: 2,
  },
  {
    title: 'Fuel Change',
    column: 'fuelChangePercentage',
    tlabel: 'MDM_FUEL_CHANGE',
    show: false,
    colSpan: 2,
  },
  {
    title: 'Freight Change',
    column: 'freightChangePercentage',
    tlabel: 'MDM_FREIGHT_CHANGE',
    show: false,
    colSpan: 2,
  },
  {
    title: 'UPDATED BDR',
    column: 'updated_bdr',
    tlabel: 'MDM_UPDATED_BDR',
    show: false,
    colSpan: 2,
  },
  {
    title: 'EFFECT FROM',
    column: 'effect_from_date',
    tlabel: 'MDM_EFFECT_FROM',
    truncateOn: 17,
    show: false,
    colSpan: 3,
  },
  {
    title: 'UPDATED DATE',
    column: 'updated_date',
    tlabel: 'MDM_UPDATED_DATE',
    truncateOn: 17,
    show: false,
    colSpan: 3,
  },
  {
    title: 'BFR LABEL',
    column: 'category',
    tlabel: 'MDM_CATEGORY',
    truncateOn: 17,
    show: false,
    colSpan: 2,
  },
  {
    title: 'ADDITIONAL FACTOR',
    column: 'additional_factor',
    tlabel: 'MDM_ADDITIONAL_FACTOR',
    show: false,
    colSpan: 2,
  },
  {
    title: 'Fuel Type',
    column: 'fuel_type',
    tlabel: 'MDM_FUEL_TYPE',
    show: false,
    colSpan: 2,
  },
  {
    title: 'Uploaded By',
    column: 'uploaded_by',
    tlabel: 'MDM_UPLOADED_BY',
    show: false,
    colSpan: 2,
  },
  {
    title: 'Updated By',
    column: 'updated_by',
    tlabel: 'MDM_UPDATED_BY',
    show: false,
    colSpan: 2,
  },
];
const container = [
  { id: 0, title: 'Name', tlabel: 'MDM_NAME', colSpan: 3, column: 'name', truncateOn: 20, show: true },
  { id: 1, title: 'Ref ID', tlabel: 'MDM_REF_ID', colSpan: 2, column: 'ref_id', truncateOn: 15, show: true },
  { id: 3, title: 'Capacity CFT', tlabel: 'MDM_CAPACITY_CFT', colSpan: 2, column: 'capacity', truncateOn: 10, show: true },
  { id: 4, title: 'Preferred truck type', tlable: 'MDM_PREFERERED_TRUCK_TYPE', colSpan: 3, column: 'preferredTruckName', truncateOn: 15, show: true },
  {
    id: 5,
    title: 'Door Opening',
    colSpan: 4,
    column: 'container_dimension_door_opening',
    tlabel: 'MDM_DOOR_OPENING',
    show: false,
    subColumnCount: 2,
    subColumns: [
      { title: 'Width', tlabel: 'MDM_WIDTH', column: 'width', colSpan: 12 },
      { title: 'Height', tlabel: 'MDM_HEIGHT', column: 'height', colSpan: 12 },
    ],
  },
  { id: 6, title: 'Tare weight(KG)', tlabel: 'MDM_TARE_WEIGHT_KG', colSpan: 4, column: 'tare_weight', show: true },
  { id: 7, title: 'Max gross weight(KG)', tlabel: 'MDM_MAX_GROSS_WEIGHT_KG', colSpan: 4, column: 'max_gross_weight', show: true },
  { id: 8, title: 'Max payload', tlabel: 'MDM_MAX_PAYLOAD_KG', colSpan: 4, column: 'max_payload', show: true },
  {
    id: 9,
    title: 'Exterior',
    colSpan: 4,
    tlabel: 'MDM_EXTERIOR',
    column: 'container_dimension_exterior',
    show: false,
    subColumnCount: 3,
    subColumns: [
      { title: 'Length', tlabel: 'MDM_LENGTH', column: 'length', colSpan: 8 },
      { title: 'Width', tlabel: 'MDM_WIDTH', column: 'width', colSpan: 8 },
      { title: 'Height', tlabel: 'MDM_HEIGHT', column: 'height', colSpan: 8 },
    ],
  },
  {
    id: 10,
    title: 'Interior',
    tlabel: 'MDM_INTERIOR',
    colSpan: 4,
    column: 'container_dimension_interior',
    show: false,
    subColumnCount: 3,
    subColumns: [
      { title: 'Length', tlabel: 'MDM_LENGTH', column: 'length', colSpan: 8 },
      { title: 'Width', tlabel: 'MDM_WIDTH', column: 'width', colSpan: 8 },
      { title: 'Height', tlabel: 'MDM_HEIGHT', column: 'height', colSpan: 8 },
    ],
  },
];

const cha = [
  { id: 0, title: 'Name', tlabel: 'MDM_NAME', colSpan: 3, column: 'name', truncateOn: 20 },
  { id: 1, title: 'Ref ID', tlabel: 'MDM_REF_ID', colSpan: 3, column: 'ref_id', truncateOn: 20 },
  { id: 2, title: 'Pan Number', tlabel: 'MDM_PAN_NUMBER', colSpan: 3, column: 'pan_number', truncateOn: 15 },
  { id: 3, title: 'GST number', tlabel: 'MDM_GST_NUMBER', colSpan: 3, column: 'gst_number', truncateOn: 15 },
  { id: 4, title: 'Port Associated', tlabel: 'MDM_PORTS_ASSOCIATED', colSpan: 4, column: 'portAssociated', wordTruncateOn: 30 },
];

const port = [
  { id: 0, title: 'Name', tlabel: 'MDM_NAME', colSpan: 3, column: 'name', truncateOn: 20 },
  { id: 1, title: 'Ref ID', tlabel: 'MDM_REF_ID', colSpan: 3, column: 'ref_id', truncateOn: 20 },
  { id: 2, title: 'Short Code', tlabel: 'MDM_SHORT_CODE', colSpan: 3, column: 'short_code', truncateOn: 20 },
  { id: 3, title: 'PORT TYPE', tlabel: 'MDM_PORT_TYPE', colSpan: 2, column: 'portType', truncateOn: 10 },
  { id: 4, title: 'City', tlabel: 'MDM_CITY', colSpan: 2, column: 'city', truncateOn: 10 },
  { id: 4, title: 'State', tlabel: 'MDM_STATE', colSpan: 2, column: 'state', truncateOn: 10 },
  { id: 4, title: 'Address', tlabel: 'MDM_ADDRESS', colSpan: 2, column: 'address', truncateOn: 10 },
  { id: 4, title: 'Country', tlabel: 'MDM_COUNTRY', colSpan: 2, column: 'country', truncateOn: 15 },
  { id: 5, title: 'GEO Code', tlabel: 'MDM_GEO_CODE', colSpan: 2, column: 'geo_code', truncateOn: 15 },
  { id: 6, title: 'PINCODE', tlabel: 'MDM_PINCODE', colSpan: 2, column: 'pin_code', truncateOn: 10 },
];

const freightforwarder = [
  { id: 0, title: 'Name', tlabel: 'MDM_NAME', colSpan: 3, column: 'name', truncateOn: 20 },
  { id: 1, title: 'Ref ID', tlabel: 'MDM_REF_ID', colSpan: 2, column: 'ref_id', truncateOn: 15 },
  { id: 2, title: 'Govt ID(PAN NO.)', tlabel: 'MDM_GOVT_ID_PAN_NUMBER', colSpan: 2, column: 'govt_id', truncateOn: 10 },
  { id: 3, title: 'Status', tlabel: 'MDM_STATUS', colSpan: 2, column: 'account_status', truncateOn: 10 },
  { id: 4, title: 'Admin name', tlabel: 'MDM_ADMIN_NAME', colSpan: 2, column: 'admin_name', truncateOn: 15 },
  { id: 5, title: 'Admin Email', tlabel: 'MDM_ADMIN_EMAIL', colSpan: 2, column: 'admin_email', truncateOn: 15 },
  { id: 6, title: 'Admin Phone', tlabel: 'MDM_ADMIN_PHONE', colSpan: 2, column: 'admin_phone', truncateOn: 10 },
];

const carton = [
  { id: 0, title: 'Code', tlabel: 'MDM_CODE', colSpan: 2, column: 'code', truncateOn: 20 },
  { id: 1, title: 'Description', tlabel: 'MDM_DESCRIPTION', colSpan: 4, column: 'description', truncateOn: 15 },
  { id: 2, title: 'Packaging', tlabel: 'MDM_PACKAGING', colSpan: 3, column: 'packaging_code', truncateOn: 20 },
  { id: 3, title: 'Weight', tlabel: 'MDM_WEIGHT', colSpan: 2, column: 'weight_kg', truncateOn: 20 },
  { id: 4, title: 'Volume', tlabel: 'MDM_VOLUME', colSpan: 2, column: 'volume_ltr', truncateOn: 20 },
  { id: 5, title: 'Length', tlabel: 'MDM_LENGTH', colSpan: 2, column: 'length_cm', truncateOn: 20 },
  { id: 6, title: 'Width', tlabel: 'MDM_WIDTH', colSpan: 2, column: 'width_cm', truncateOn: 20 },
  { id: 7, title: 'Height', tlabel: 'MDM_HEIGHT', colSpan: 2, column: 'height_cm', truncateOn: 10 },
];

const carrier = [
  { id: 0, title: 'Code', tlabel: 'MDM_CODE', colSpan: 3, column: 'code', truncateOn: 20 },
  { id: 1, title: 'Service', tlabel: 'MDM_SERVICE', colSpan: 3, column: 'service', truncateOn: 20 },
  { id: 2, title: 'Description', tlabel: 'MDM_DESCRIPTION', colSpan: 3, column: 'description', truncateOn: 20 },
];

const shipmethod = [
  { id: 0, title: 'Code', tlabel: 'MDM_CODE', colSpan: 2, column: 'code', truncateOn: 20, show: true },
  { id: 1, title: 'Description', tlabel: 'MDM_DESCRIPTION', colSpan: 3, column: 'description', truncateOn: 20, show: true },
  { id: 2, title: 'Default Regulation', tlabel: 'MDM_DEFAULT_REGULATION', colSpan: 2, column: 'default_regulation_label', truncateOn: 20, show: true },
  { id: 3, title: 'CAUTION CODE', tlabel: 'MDM_CAUTION_CODE', colSpan: 3, column: 'caution_codes', truncateOn: 20, show: true },
  { id: 4, title: 'Mode Of Transport', tlabel: 'MDM_MODE_OF_TRANSPORT', colSpan: 2, column: 'transport_code', truncateOn: 10, show: true },
  { id: 5, title: 'Domestic Carriers', tlabel: 'MDM_DOMESTIC_COURIER', colSpan: 2, column: 'domestic_carriers_description', wordTruncateOn: 30, show: true },
  { id: 6, title: 'Domestic Carrier Default', tlabel: 'MDM_DOMESTIC_COURIER_DEFAULT', colSpan: 2, column: 'domestic_carrier_default_description', truncateOn: 15, show: true },
  { id: 7, title: 'International Carriers', tlabel: 'MDM_INTERNATIONAL_CARRIER', colSpan: 2, column: 'international_carriers_description', wordTruncateOn: 30, show: true },
  { id: 8, title: 'International Carrier Default', tlabel: 'MDM_INTERNATIONAL_CARRIER_DEFAULT', colSpan: 3, column: 'international_carrier_default_description', truncateOn: 20, show: true },
  { id: 9, title: 'Domestic transport mode', tlabel: 'MDM_DOMESTIC_TRANSPORT_MODE', colSpan: 2, column: 'domestic_transport_mode', truncateOn: 20, show: false },
  { id: 10, title: 'International transport mode', tlabel: 'MDM_INTERNATIONAL_TRANSPORT_MODE', colSpan: 2, column: 'international_transport_mode', truncateOn: 20, show: false },
];

const transportationdb = [
  { id: 0, title: 'Sku', colSpan: 2, column: 'sku', tlabel: 'MDM_TRANSPORTATION_SKU', truncateOn: 15, show: true },
  { id: 1, title: 'Transport Mode', colSpan: 3, tlabel: 'MDM_TRANSPORTATION_MODE', column: 'transport_mode', truncateOn: 20, show: true },
  { id: 2, title: 'Max Qty', colSpan: 2, tlabel: 'MDM_TRANSPORTATION_MAX_QTY', column: 'max_qty', truncateOn: 20, show: true },
  { id: 3, title: 'Category', colSpan: 3, tlabel: 'MDM_TRANSPORTATION_CATEGORY', column: 'category', truncateOn: 20, show: true },
  { id: 4, title: 'Pkg Detail', colSpan: 2, tlabel: 'MDM_TRANSPORTATION_PKG_DETAIL', column: 'pkg_detail', truncateOn: 10, show: true },
  { id: 5, title: 'Vol', colSpan: 2, tlabel: 'MDM_TRANSPORTATION_VOL', column: 'vol', show: true },
  { id: 6, title: 'UOM', colSpan: 2, tlabel: 'MDM_TRANSPORTATION_UNIT_OF_MEASURE', column: 'uom', truncateOn: 15, show: true },
  { id: 7, title: 'Service Code', colSpan: 2, tlabel: 'MDM_TRANSPORTATION_SERVICE_CODE', column: 'service_code', show: false },
  { id: 8, title: 'Content ID', colSpan: 3, tlabel: 'MDM_TRANSPORTATION_CONTENT_ID', column: 'content_id', truncateOn: 20, show: false },
  { id: 9, title: 'Inner quantity', colSpan: 3, tlabel: 'MDM_TRANSPORTATION_INNER_QUANTITY', column: 'inner_quantity', truncateOn: 20, show: false },
];

const transporter = [
  { id: 0, title: 'Name', tlabel: 'MDM_NAME', colSpan: 4, column: 'name', truncateOn: 25, show: true },
  { id: 1, title: 'Reference Id', colSpan: 3, tlabel: 'MDM_REFERENCE_ID', column: 'reference_id', truncateOn: 15, show: true },
  { id: 2, title: 'Address', colSpan: 4, tlabel: 'MDM_ADDRESS', column: 'address', truncateOn: 25, show: false },
  { id: 3, title: 'City', colSpan: 3, tlabel: 'MDM_CITY', column: 'city', truncateOn: 20, show: true },
  { id: 4, title: 'State', colSpan: 3, tlabel: 'MDM_STATE', column: 'state', truncatedOn: 20, show: true },
  { id: 6, title: 'Postal code', colSpan: 2, tlabel: 'MDM_PINCODE', column: 'pincode', show: true },
  { id: 7, title: 'Country', colSpan: 2, tlabel: 'MDM_COUNTRY', column: 'country', show: false },
  { id: 8, title: 'Pan No', colSpan: 2, tlabel: 'MDM_PAN_NUMBER', column: 'pan_no', show: false },
  { id: 9, title: 'Status', colSpan: 2, tlabel: 'MDM_STATUS', column: 'statusText', show: true },
  { id: 10, title: 'GST Type', colSpan: 2, tlabel: 'MDM_GST_TYPE', column: 'gst_name', show: true },
  { id: 11, title: 'Updated by', colSpan: 3, tlabel: 'MDM_UPDATED_BY', column: 'updated_by', truncateOn: 20, show: false },
  { id: 12, title: 'Updated Date', colSpan: 3, tlabel: 'MDM_UPDATED_DATE', column: 'updated_date', truncateOn: 17, show: false },
  { id: 13, title: 'GST Percentage', colSpan: 2, tlabel: 'MDM_GST_PERCENTAGE', column: 'gst_percentage', show: false },
  { id: 14, title: 'Discount', colSpan: 2, tlabel: 'MDM_DISCOUNT_PER', column: 'discount', show: false, feature: 'transporter_payment_discount' },
  { id: 15, title: 'Generate LR', colSpan: 2, tlabel: 'MDM_GENERATE_LR', column: 'generate_lr', show: false, feature: 'generate_lr' },
  { id: 16, title: 'Auto Extend LR Series', colSpan: 2, tlabel: 'MDM_AUTO_EXTEND_LR_SERIES', column: 'auto_extend_lr_series', show: false, feature: 'generate_lr' },
];

const billdiscount = [
  { id: 0, title: 'Program ID', colSpan: 3, tlabel: 'MDM_PROGRAM_ID', column: 'program_id', show: true },
  { id: 1, title: 'Days Early', colSpan: 3, tlabel: 'MDM_DAYS_EARLY', column: 'days_early', show: true },
  { id: 2, title: 'Discount Rate (%)', colSpan: 3, tlabel: 'MDM_DISCOUNT_RATE', column: 'discount_rate', show: true },
];

const vehicledetail = [
  { id: 0, title: 'Vehicle Number', colSpan: 3, column: 'number', tlabel: 'MDM_VEHICLE_NUMBER', show: true },
  { id: 1, title: 'Vehicle Type', colSpan: 2, column: 'vehicle_type', tlabel: 'MDM_VEHICLE_NAME', truncatedOn: 10, show: true },
  { id: 2, title: 'Vehicle Model', colSpan: 3, column: 'vehicle_model', tlabel: 'MDM_VEHICLE_MODEL', truncatedOn: 10, show: true },
  { id: 3, title: 'Transporter Name', colSpan: 3, tlabel: 'MDM_TRANSPORTER_NAME', column: 'transporter', truncatedOn: 10, show: true },
  { id: 4, title: 'Chassis Number', colSpan: 4, column: 'chasis_number', tlabel: 'MDM_CHASIS_NUMBER', truncatedOn: 10, show: true },
  { id: 5, title: 'Vehicle available In', colSpan: 5, column: 'depot_availability', tlabel: 'MDM_AVAILABILITY_IN', wordTruncateOn: 26, show: false, type: 'list' },
  { id: 6, title: 'Fuel Type', colSpan: 3, column: 'fuel_type', tlabel: 'MDM_FUEL_TYPE', truncatedOn: 10, show: false, feature: 'vahan_validation' },
];

const contract = [
  { id: 0, title: 'Type', tlabel: 'MDM_TYPE', colSpan: 2, column: 'type', truncateOn: 15, show: true },
  { id: 1, title: 'Status', tlabel: 'MDM_STATUS', colSpan: 2, column: 'status', truncateOn: 15, show: true },
  { id: 2, title: 'Source', tlabel: 'MDM_SOURCE', colSpan: 2, column: 'source', truncateOn: 15, show: true },
  { id: 3, title: 'Destination', tlabel: 'MDM_DESTINATION', colSpan: 2, column: 'destination', truncateOn: 25, show: true },
  { id: 4, title: 'Vehicle Name', tlabel: 'MDM_VEHICLE_NAME', colSpan: 2, column: 'vehicle_type', truncateOn: 25, show: true },
  { id: 5, title: 'Distance', tlabel: 'MDM_DISTANCE', colSpan: 2, column: 'distance', show: false },
  { id: 6, title: 'Trans Ref Id', tlabel: 'MDM_TRANS_REF_ID', colSpan: 2, column: 'transporter_reference_id', truncateOn: 20, show: false },
  { id: 7, title: 'Transporter Name', tlabel: 'MDM_TRANSPORTER_NAME', colSpan: 3, column: 'transporter_name', truncateOn: 20, show: true },
  { id: 8, title: 'Transit Days', tlabel: 'MDM_TRANSIT_DAYS', colSpan: 2, column: 'transit_time', show: false },
  { id: 9, title: 'Detention Group', tlabel: 'MDM_DETENTION_GROUP', colSpan: 2, column: 'group_code', truncateOn: 25, show: false },
  { id: 10, title: 'Valid From', tlabel: 'MDM_VALID_FROM', colSpan: 2, column: 'start', show: true },
{ id: 11, title: 'Valid To', tlabel: 'MDM_VALID_TO', colSpan: 2, column: 'end', show: true },
  { id: 12, title: 'Rate', tlabel: 'MDM_RATE', colSpan: 2, column: 'freight_rate', show: true },
  { id: 13, title: 'Unit', tlabel: 'MDM_UNIT', colSpan: 2, column: 'freight_unit', truncateOn: 10, show: true },
  { id: 14, title: 'Updated by', tlabel: 'MDM_UPDATED_BY', colSpan: 3, column: 'updated_by', truncateOn: 20, show: false },
  { id: 15, title: 'Updated date', tlabel: 'MDM_UPDATED_DATE', colSpan: 3, column: 'updated_at', truncateOn: 20, show: false },
  { id: 16, title: 'Uploaded By', tlabel: 'Uploaded By', colSpan: 3, column: 'uploaded_by', truncateOn: 20, show: false },
  { id: 17, title: 'Uploaded Date', tlabel: 'Uploaded Date', colSpan: 3, column: 'uploaded_at', truncateOn: 20, show: false },
  { id: 18, title: 'Minimum Rate', tlabel: 'MDM_MINIMUM_RATE', colSpan: 2, column: 'minimum_rate', show: false },
  { id: 19, title: 'Multiplying Factor', tlabel: 'MDM_MULTIPLYING_FACTOR', colSpan: 2, column: 'multiplying_factor', show: false },
  { id: 20, title: 'Route Exclude', tlabel: 'MDM_ROUTE_EXCLUDE', colSpan: 2, column: 'route_exclude', show: false },
  { id: 21, title: 'Trip Count', tlabel: 'MDM_TRIP_COUNT', colSpan: 2, column: 'trip_count', show: false },
  { id: 22, title: 'Fixed Rate', tlabel: 'MDM_FIXED_RATE', colSpan: 2, column: 'fixed_rate', show: false },
  { id: 23, title: 'Oda Rate', tlabel: 'MDM_ODA_RATE', colSpan: 2, column: 'oda_rate', show: false },
  { id: 24, title: 'Oda Unit', tlabel: 'MDM_ODA_UNIT', colSpan: 2, column: 'oda_unit', show: false },
  { id: 25, title: 'Minimum Oda', tlabel: 'MDM_MINIMUM_ODA', colSpan: 2, column: 'minimum_oda', show: false },
  { id: 26, title: 'Drop Point Charges', tlabel: 'MDM_DROP_POINT_CHARGES', colSpan: 2, column: 'point_charges', show: false },
  { id: 27, title: 'Is Dedicated', tlabel: 'MDM_IS_DEDICATED', colSpan: 2, column: 'is_dedicated', show: false },
  { id: 28, title: 'Truck Count', tlabel: 'MDM_TRUCK_COUNT', colSpan: 2, column: 'truck_count', show: false },
  { id: 29, title: 'Running Count', tlabel: 'MDM_RUNNING_COUNT', colSpan: 2, column: 'running_trip_count', show: false },
  { id: 30, title: 'Additional Charge %', tlabel: 'MDM_ADDITIONAL_CHARGE_PERCENTAGE', colSpan: 2, column: 'additional_charge_percentage', show: false },
  { id: 31, title: 'Hilly Region Addition %', tlabel: 'MDM_HILLY_REGION_ADDITION_PERCENTAGE', colSpan: 2, column: 'hilly_region_addition_percentage', show: false },
  { id: 32, title: 'Is Round Trip Eligible', tlabel: 'MDM_IS_ROUND_TRIP_ELIGIBLE', colSpan: 3, column: 'is_round_trip_eligible', show: false },
  { id: 33, title: 'Return Freight Rate', tlabel: 'MDM_RETURN_FREIGHT_RATE', colSpan: 2, column: 'return_freight_rate', show: false },
  { id: 34, title: 'Pickup Point Charges', tlabel: 'MDM_PICKUP_POINT_CHARGES', colSpan: 2, column: 'pickup_point_charges', show: false },
  { id: 35, title: 'Surge Threshold', tlabel: 'MDM_SURGE_THRESHOLD', colSpan: 2, column: 'surge_threshold', show: false },
  { id: 36, title: 'Indent Cancellation Charge', tlabel: 'MDM_INDENT_CANCELLATION_CHARGE', colSpan: 2, column: 'indent_cancellation_charge', show: false },
  { id: 37, title: 'ROV Percentage', tlabel: 'MDM_ROV_CHARGE_PERCENTAGE', colSpan: 2, column: 'rov_charge_percentage', show: false },
  { id: 38, title: 'ROV Minimum Value', tlabel: 'MDM_ROV_MINIMUM_VALUE', colSpan: 2, column: 'minimum_rov_charges', show: false },
  { id: 39, title: 'Is Owned', tlabel: 'MDM_IS_OWNED', colSpan: 2, column: 'is_owned', show: false },
];

const consignee = [
  { id: 0, title: 'Name', tlabel: 'MDM_NAME', colSpan: 3, column: 'name', truncateOn: 22, show: true },
  { id: 1, title: 'Ref Id', tlabel: 'MDM_REF_ID', colSpan: 3, column: 'reference_id', truncateOn: 12, show: true },
  { id: 2, title: 'Address', tlabel: 'MDM_ADDRESS', colSpan: 4, column: 'address', truncateOn: 20, show: true },
  { id: 3, title: 'City', tlabel: 'MDM_CITY', colSpan: 2, column: 'city', truncateOn: 12, show: true },
  { id: 4, title: 'State', tlabel: 'MDM_STATE', colSpan: 3, column: 'state', truncateOn: 10, show: true },
  { id: 5, title: 'Pincode', tlabel: 'MDM_PINCODE', colSpan: 2, column: 'pincode', truncateOn: 25, show: true },
  { id: 6, title: 'Region', tlabel: 'MDM_REGION', colSpan: 2, column: 'region', show: true },
  { id: 7, title: 'Group', tlabel: 'MDM_GROUP', colSpan: 2, column: 'group', truncateOn: 22, show: false },
  { id: 8, title: 'Country', tlabel: 'MDM_COUNTRY', colSpan: 2, column: 'country', truncateOn: 22, show: true },
  { id: 9, title: 'Updated By', tlabel: 'MDM_UPDATED_BY', colSpan: 3, column: 'updated_by', truncateOn: 22, show: false },
  { id: 10, title: 'Updated Date', tlabel: 'MDM_UPDATED_DATE', colSpan: 3, column: 'updated_at', truncateOn: 22, show: false },
  { id: 11, title: 'Rep Name', tlabel: 'MDM_REP_NAME', colSpan: 2, column: 'manager', truncateOn: 15, show: false },
  { id: 12, title: 'Rep Mobile', tlabel: 'MDM_REP_MOBILE', colSpan: 2, column: 'phone', truncateOn: 10, show: false },
  { id: 13, title: 'Rep Email', tlabel: 'MDM_REP_EMAIL', colSpan: 3, column: 'email_id', truncateOn: 25, show: false },
  { id: 14, title: 'Exclude Truck Type', tlabel: 'MDM_EXCLUDE_TRUCK_TYPE', label: 'exclude_vehicles_list', colSpan: 3, config: 'hide_exclude_vehicles', column: 'exclude_vehicles', show: false },
  { id: 15, title: 'Port Association', tlabel: 'MDM_PORT_ASSOCIATION', colSpan: 3, column: 'port_association_list', features: 'exim_enabled', show: false },
  { id: 16, title: 'Status', tlabel: 'MDM_STATUS', colSpan: 3, column: 'account_status', show: false },
  { id: 17, title: 'Lat', tlabel: 'MDM_LAT', colSpan: 2, column: 'lat', truncateOn: 9, show: false },
  { id: 18, title: 'Long', tlabel: 'MDM_LONG', colSpan: 2, column: 'long', truncateOn: 9, show: false },
  { id: 19, title: 'Combine', tlabel: 'MDM_COMBINE', colSpan: 2, column: 'combine_allowed', show: false },
  { id: 20, title: 'Category', tlabel: 'MDM_CATEGORY', colSpan: 3, column: 'category', show: false },
  { id: 21, title: 'Optima Category', tlabel: 'MDM_OPTIMA_CATEGORY', colSpan: 3, column: 'optima_category', show: false },
  { id: 22, title: 'Sales name', tlabel: 'MDM_SALES_NAME', colSpan: 3, column: 'sales_name', show: false },
  { id: 23, title: 'Sales email', tlabel: 'MDM_SALES_EMAIL', colSpan: 3, column: 'sales_email', show: false },
  { id: 24, title: 'Sales ph.no', tlabel: 'MDM_SALES_PHONE_NO', colSpan: 3, column: 'sales_phone', show: false },
  { id: 25, title: 'Delivery Do Not Combine', tlabel: 'MDM_DELIVERY_DO_NOT_COMBINE', colSpan: 3, column: 'delivery_do_not_combine', show: false },
  { id: 26, title: 'Loading time', tlabel: 'MDM_LOADING_TIME', colSpan: 3, column: 'loading_start_end', show: false },
  { id: 27, title: 'Unloading time', tlabel: 'MDM_UNLOADING_TIME', colSpan: 3, column: 'unloading_start_end', show: false },
  { id: 28, title: 'Customer Logistic Leader', tlabel: 'MDM_CUSTOMER_LOGISTIC_LEADER', colSpan: 3, column: 'customer_logistic_leader', show: false },
  { id: 29, title: 'Logistics Spoc Email Id', tlabel: 'MDM_DISTRIBUTION_EMAILS', colSpan: 3, column: 'distribution_emails', truncateOn: 12, show: false },
  { id: 30, title: 'Logistics Spoc Phone Number', tlabel: 'MDM_PHONE_NUMBER', colSpan: 3, column: 'phone_number', truncateOn: 10, show: false },
  { id: 31, title: 'Notifications Enabled', tlabel: 'MDM_NOTIFICATIONS_ENABLED', colSpan: 3, column: 'notifications_enabled', show: false },
  { id: 32, title: 'Courier Ref Id', tlabel: 'MDM_COURIER_REF_ID', colSpan: 3, column: 'courier_ref_id', show: false },
  { id: 32, title: 'Login Active Status', tlabel: 'MDM_LOGIN_ACTIVE_STATUS', colSpan: 3, column: 'login_active_status', show: false },
];

const contracttsd = [
  { id: 0, colSpan: 3, title: 'Source', tlabel: 'MDM_SOURCE', truncateOn: 20, show: true, column: 'source' },
  { id: 1, colSpan: 3, title: 'Destination', tlabel: 'MDM_DESTINATION', truncateOn: 20, show: true, column: 'destination' },
  { id: 2, colSpan: 3, title: 'Transporter Reference Id', tlabel: 'MDM_TRANS_REF_ID', truncateOn: 20, show: true, column: 'transporter_reference_id' },
  { id: 3, colSpan: 3, title: 'Transporter Name', tlabel: 'MDM_TRANSPORTER_NAME', truncateOn: 20, show: true, column: 'transporter_name' },
  { id: 4, colSpan: 3, title: 'Vehicle Name', tlabel: 'MDM_VEHICLE_NAME', truncateOn: 20, show: true, column: 'vehicle_type' },
  { id: 5, colSpan: 3, title: 'Updated By', tlabel: 'MDM_UPDATED_BY', truncateOn: 17, show: false, column: 'updated_by' },
  { id: 6, colSpan: 3, title: 'Updated Date', tlabel: 'MDM_UPDATED_DATE', truncateOn: 17, show: false, column: 'updated_date' },
  { id: 7, colSpan: 3, title: 'Ratio', tlabel: 'MDM_RATIO', truncateOn: 20, show: true, column: 'distribution_ratio' },
  { id: 8, colSpan: 3, title: 'Percentage', tlabel: 'MDM_PERCENTAGE', truncateOn: 20, show: true, column: 'distribution_percentage' },
  { id: 9, colSpan: 4, title: 'Indent Distribution Count', tlabel: 'MDM_INDENT_DISTRIBUTION_COUNT', truncateOn: 20, show: false, column: 'count' },
  { id: 10, colSpan: 4, title: 'Movement', tlabel: 'MDM_MOVEMENT', truncateOn: 20, show: false, column: 'movement' },
];

const destination_charge = [
  { id: 0, label: 'Destination Type', tlabel: 'MDM_DESTINATION_TYPE', colSpan: 3, column: 'destination_type', truncateOn: 22, show: true },
  { id: 1, label: 'Destination', tlabel: 'MDM_DESTINATION_CHARGE_DESTINATION', colSpan: 3, column: 'destination', truncateOn: 22, show: true },
  { id: 2, label: 'Movement', tlabel: 'MDM_DESTINATION_CHARGE_MOVEMENT', colSpan: 3, column: 'movement', truncateOn: 22, show: true },
  { id: 3, label: 'Transporter Ref Id', tlabel: 'MDM_DESTINATION_CHARGE_TRANSPORTER_REF_ID', colSpan: 3, column: 'transporter_ref_id', truncateOn: 22, show: true },
  { id: 4, label: 'Vehicle Type', tlabel: 'MDM_DESTINATION_CHARGE_VEHICLE_TYPE', colSpan: 3, column: 'vehicle_type', truncateOn: 22, show: true },
  { id: 5, label: 'Charge Code', tlabel: 'MDM_DESTINATION_CHARGE_CODE', colSpan: 3, column: 'charge_code', truncateOn: 22, show: true },
  { id: 6, label: 'Remarks', tlabel: 'MDM_DESTINATION_REMARKS', colSpan: 3, column: 'remarks', truncateOn: 22, show: false },
];

const user = [
  { id: 0, title: 'Name', column: 'name', tlabel: 'MDM_NAME', truncateOn: 20, show: true, colSpan: 3 },
  { id: 1, title: 'Status', column: 'account_status', tlabel: 'MDM_STATUS', truncateOn: 20, show: true, colSpan: 3 },
  { id: 2, title: 'Role', column: 'account_role', tlabel: 'MDM_ROLE', show: true, colSpan: 3 },
  { id: 3, title: 'Phone', column: 'mobile', tlabel: 'MDM_PHONE', show: true, colSpan: 3 },
  { id: 4, title: 'EMAIL', column: 'email', tlabel: 'MDM_EMAIL', truncateOn: 15, show: true, colSpan: 3 },
  { id: 5, title: 'Updated By', column: 'Updated_By', tlabel: 'MDM_UPDATED_BY', truncateOn: 15, show: true, colSpan: 3 },
  { id: 6, title: 'Updated Date', column: 'updated_at_formatted', tlabel: 'MDM_UPDATED_DATE', show: true, colSpan: 3 },
];

const package_master = [
  { id: 0, title: 'Package id', column: 'package_id', tlabel: 'MDM_PACKAGE_ID', truncateOn: 30, show: true, colSpan: 2, is_searchable: true },
  { id: 1, title: 'Description', column: 'description', tlabel: 'MDM_PACKAGE_DESCRIPTION', truncateOn: 30, show: true, colSpan: 3 },
  { id: 2, title: 'Type', column: 'type', tlabel: 'MDM_PACKAGE_TYPE', truncateOn: 30, show: true, colSpan: 3 },
  { id: 3, title: 'Max stack', column: 'max_stack', tlabel: 'MDM_PACKAGE_MAX_STACK', truncateOn: 30, show: false, colSpan: 3 },
  { id: 4, title: 'Weight', column: 'weight', tlabel: 'MDM_PACKAGE_WEIGHT', truncateOn: 30, show: false, colSpan: 3 },
  { id: 5, title: 'Volume', column: 'volume', tlabel: 'MDM_PACKAGE_VOLUME', truncateOn: 30, show: false, colSpan: 3 },
  { id: 6, title: 'length', column: 'length', tlabel: 'MDM_PACKAGE_LENGTH', truncateOn: 30, show: true, colSpan: 3 },
  { id: 7, title: 'breadth', column: 'breadth', tlabel: 'MDM_PACKAGE_BREADTH', truncateOn: 30, show: true, colSpan: 3 },
  { id: 8, title: 'height', column: 'height', tlabel: 'MDM_PACKAGE_HEIGHT', truncateOn: 30, show: true, colSpan: 3 },
  { id: 9, title: 'weight_capacity', column: 'weight_capacity', tlabel: 'MDM_PACKAGE_WEIGHT_CAPACITY', truncateOn: 30, show: false, colSpan: 3 },
  { id: 10, title: 'volume_capacity', column: 'volume_capacity', tlabel: 'MDM_PACKAGE_VOLUME_CAPACITY', truncateOn: 30, show: false, colSpan: 3 },
  { id: 11, title: 'loadType', column: 'load_type', tlabel: 'MDM_PACKAGE_LOAD_TYPE', truncateOn: 30, show: false, colSpan: 3 },
  { id: 12, title: 'can_load_on_top', column: 'can_load_on_top', tlabel: 'MDM_PACKAGE_CAN_LOAD_ON_TOP', truncateOn: 30, show: false, colSpan: 3 },
  { id: 13, title: 'max_no_sku', column: 'max_no_sku', tlabel: 'MDM_PACKAGE_MAX_SKU', truncateOn: 30, show: false, colSpan: 3 },
  { id: 14, title: 'max_in_truck', column: 'max_in_truck', tlabel: 'MDM_PACKAGE_MAX_IN_TRUCK', truncateOn: 30, show: false, colSpan: 3 },
  { id: 15, title: 'max_weight', column: 'max_weight', tlabel: 'MDM_PACKAGE_MAX_WEIGHT', truncateOn: 30, show: false, colSpan: 3 },
  { id: 16, title: 'max_materials', column: 'max_materials', tlabel: 'MDM_PACKAGE_MAX_MATERIALS', truncateOn: 30, show: false, colSpan: 3 },
];

const material_package_map = [
  { id: 0, title: 'Package id', column: 'package_id', tlabel: 'MDM_PACKAGE_ID', truncateOn: 30, show: true, colSpan: 2, is_searchable: true },
  { id: 1, title: 'Description', column: 'description', tlabel: 'MDM_PACKAGE_DESCRIPTION', truncateOn: 30, show: true, colSpan: 3 },
  { id: 2, title: 'Type', column: 'type', tlabel: 'MDM_PACKAGE_TYPE', truncateOn: 30, show: true, colSpan: 3 },
  { id: 3, title: 'Max stack', column: 'max_stack', tlabel: 'MDM_PACKAGE_MAX_STACK', truncateOn: 30, show: false, colSpan: 3 },
  { id: 4, title: 'Weight', column: 'weight', tlabel: 'MDM_PACKAGE_WEIGHT', truncateOn: 30, show: false, colSpan: 3 },
  { id: 5, title: 'Volume', column: 'volume', tlabel: 'MDM_PACKAGE_VOLUME', truncateOn: 30, show: false, colSpan: 3 },
  { id: 6, title: 'length', column: 'length', tlabel: 'MDM_PACKAGE_LENGTH', truncateOn: 30, show: true, colSpan: 3 },
  { id: 7, title: 'breadth', column: 'breadth', tlabel: 'MDM_PACKAGE_BREADTH', truncateOn: 30, show: true, colSpan: 3 },
  { id: 8, title: 'height', column: 'height', tlabel: 'MDM_PACKAGE_HEIGHT', truncateOn: 30, show: true, colSpan: 3 },
  { id: 9, title: 'weight_capacity', column: 'weight_capacity', tlabel: 'MDM_PACKAGE_WEIGHT_CAPACITY', truncateOn: 30, show: false, colSpan: 3 },
  { id: 10, title: 'volume_capacity', column: 'volume_capacity', tlabel: 'MDM_PACKAGE_VOLUME_CAPACITY', truncateOn: 30, show: false, colSpan: 3 },
];

const depot = [
  { id: 0, title: 'Depot Name', column: 'name', tlabel: 'MDM_DEPOT_NAME', truncateOn: 15, show: true, colSpan: 3 },
  { id: 1, title: 'Refrence ID', column: 'reference_id', tlabel: 'MDM_REF_ID', show: true, colSpan: 3 },
  { id: 2, title: 'Type', column: 'plant_type_name', tlabel: 'MDM_TYPE', show: true, colSpan: 2 },
  { id: 3, title: 'City', column: 'city', tlabel: 'MDM_CITY', truncateOn: 12, show: true, colSpan: 2 },
  { id: 4, title: 'State', column: 'state', tlabel: 'MDM_STATE', truncateOn: 12, show: true, colSpan: 2 },
  { id: 5, title: 'DELIVERY TYPE', column: 'delivery_type_name', tlabel: 'MDM_DELIVERY_TYPE', show: true, colSpan: 4 },
  { id: 6, title: 'Region', column: 'region', tlabel: 'MDM_REGION', show: true, colSpan: 3 },
  { id: 7, title: 'Contact', column: 'phone', tlabel: 'MDM_CONTACT', show: true, colSpan: 2 },
  { id: 8, title: 'Zip Code', column: 'pincode', tlabel: 'MDM_PINCODE', show: false, colSpan: 2 },
  { id: 9, title: 'SHT CODE', column: 'short_code', tlabel: 'MDM_SHT_CODE', show: false, colSpan: 3 },
  { id: 10, title: 'Port Association', column: 'port_association_list', tlabel: 'MDM_PORT_ASSOCIATION', show: false, colSpan: 3 },
  { id: 11, title: 'Unloading Capacity', column: 'unloading_capacity', tlabel: 'MDM_UNLOADING_CAPACITY', show: false, colSpan: 3 },
  { id: 12, title: 'Timezone', column: 'timezone', tlabel: 'MDM_TIMEZONE', truncateOn: 17, show: false, colSpan: 3 },
  { id: 13, title: 'Fax Number', column: 'fax_number', tlabel: 'MDM_FAX_NUMBER', truncateOn: 17, show: false, colSpan: 3 },
  { id: 14, title: 'Display Reference Name', column: 'display_reference_name', tlabel: 'MDM_DISPLAY_REFERENCE_NAME', truncateOn: 17, show: false, colSpan: 3 },
  { id: 15, title: 'Cluster', column: 'is_optima_group_by_cluster', tlabel: 'MDM_OPTIMA_CLUSTER', truncateOn: 17, show: false, colSpan: 3 },
  { id: 16, title: 'Associate Material Categories', column: 'associated_material_categories_list', tlabel: 'MDM_ASC_MATERIAL_CATEGORIES', truncateOn: 17, show: false, colSpan: 3 },
  { id: 17, title: 'Updated by', column: 'updated_by', tlabel: 'MDM_UPDATED_BY', truncateOn: 17, show: false, colSpan: 3 },
  { id: 18, title: 'Updated date', column: 'updated_at', tlabel: 'MDM_UPDATED_DATE', truncateOn: 17, show: false, colSpan: 3 }];

const sla = [
  { id: 0, title: 'Depot Name', column: 'depotName', tlabel: 'MDM_DEPOT_NAME', truncateOn: 12, show: true, colSpan: 3 },
  { id: 1, title: 'Movement', column: 'movement_formatted', tlabel: 'MDM_MOVEMENT', show: true, colSpan: 3 },
  { id: 2, title: 'Vehicle Name', column: 'vehicleName', tlabel: 'MDM_VEHICLE_NAME', show: true, truncateOn: 15, colSpan: 3 },
  { id: 3, title: 'Acceptance', column: 'acceptanceDelayCost', tlabel: 'MDM_ACCEPTANCE', show: true, colSpan: 3 },
  { id: 4, title: 'Assignment', column: 'assignmentDelayCost', tlabel: 'MDM_ASSIGNMENT', show: true, colSpan: 3 },
  { id: 5, title: 'Arrival', column: 'arrivalDelayCost', tlabel: 'MDM_ARRIVAL', show: true, colSpan: 3 },
  { id: 6, title: 'Updated By', column: 'updated_by', tlabel: 'MDM_UPDATED_BY', truncateOn: 17, show: false, colSpan: 3 },
  { id: 7, title: 'Updated Date', column: 'updated_at_formatted', tlabel: 'MDM_UPDATED_DATE', truncateOn: 17, show: false, colSpan: 3 },
  { id: 8, title: 'Rejection', column: 'rejectionCost', tlabel: 'MDM_REJECTION', show: false, colSpan: 3 },
  { id: 9, title: 'Grace Period', column: 'gracePeriod', tlabel: 'MDM_GRACE_PERIOD', show: false, colSpan: 3 },
  { id: 10, title: 'Max Arrival SLA (%)', column: 'max_arrival_sla', tlabel: 'MDM_MAX_ARRIVAL_SLA_PERCENTAGE', show: false, colSpan: 3 },
];

const approval = [
  { id: 0, title: 'Type', column: 'entity_type', tlabel: 'MDM_TYPE', truncateOn: 20, show: true, colSpan: 3, type: 'text' },
  { id: 1, title: 'File', column: 'file', tlabel: 'MDM_FILE', truncateOn: 20, show: true, colSpan: 3, type: 'downloadButton' },
  { id: 2, title: 'Uploaded By', column: 'uploaded_by', tlabel: 'MDM_UPLOADED_BY', show: true, colSpan: 3, type: 'text', truncateOn: 20 },
  { id: 3, title: 'Action By', column: 'action_by', tlabel: 'MDM_ACTION_BY', show: true, colSpan: 3, type: 'text', truncateOn: 20 },
  { id: 4, title: 'Status', column: 'status_text', tlabel: 'MDM_STATUS', truncateOn: 25, show: true, colSpan: 3 },
  { id: 5, title: 'Updated Date', column: 'updated_at', tlabel: 'MDM_UPDATED_DATE', show: true, colSpan: 3, type: 'date' },
  { id: 6, title: 'Remarks', column: 'remarks', tlabel: 'MDM_REMARKS', truncateOn: 25, show: true, colSpan: 3, type: 'text' },
];

const detention = [
  { id: 0, title: 'Vehicle Name', tlabel: 'MDM_VEHICLE_NAME', colSpan: 5, column: 'vehicle_type', truncateOn: 20, show: true },
  { id: 1, title: 'Group', tlabel: 'MDM_GROUP', colSpan: 3, column: 'group_code', truncateOn: 20, show: true },
  { id: 2, title: 'Movement', tlabel: 'MDM_MOVEMENT', colSpan: 3, column: 'movement', truncateOn: 20, show: true },
  {
    id: 3,
    title: 'Loading Detention',
    colSpan: 18,
    column: 'loading_detention',
    tlabel: 'MDM_LOADING_DETENTION',
    show: true,
    subColumnCount: 6,
    subColumns: [
      { title: 'Day1', tlabel: 'MDM_DAY1', column: '0', colSpan: 4 },
      { title: 'Day2', tlabel: 'MDM_DAY2', column: '1', colSpan: 4 },
      { title: 'Day3', tlabel: 'MDM_DAY3', column: '2', colSpan: 4 },
      { title: 'Day4', tlabel: 'MDM_DAY4', column: '3', colSpan: 4 },
      { title: 'Day5', tlabel: 'MDM_DAY5', column: '4', colSpan: 4 },
      { title: 'Day6', tlabel: 'MDM_DAY6', column: '5', colSpan: 4 },
    ],
  },
  {
    id: 4,
    title: 'UnLoading Detention',
    colSpan: 18,
    column: 'unloading_detention',
    tlabel: 'MDM_UNLOADING_DETENTION',
    show: true,
    subColumnCount: 6,
    subColumns: [
      { title: 'Day1', tlabel: 'MDM_DAY1', column: '0', colSpan: 4 },
      { title: 'Day2', tlabel: 'MDM_DAY2', column: '1', colSpan: 4 },
      { title: 'Day3', tlabel: 'MDM_DAY3', column: '2', colSpan: 4 },
      { title: 'Day4', tlabel: 'MDM_DAY4', column: '3', colSpan: 4 },
      { title: 'Day5', tlabel: 'MDM_DAY5', column: '4', colSpan: 4 },
      { title: 'Day6', tlabel: 'MDM_DAY6', column: '5', colSpan: 4 },
    ],
  },
  {
    id: 5,
    title: 'Transit Delay',
    colSpan: 18,
    column: 'delay',
    tlabel: 'MDM_TRANSIT_DELAY',
    show: false,
    subColumnCount: 6,
    subColumns: [
      { title: 'Day1', tlabel: 'MDM_DAY1', column: '0', colSpan: 4 },
      { title: 'Day2', tlabel: 'MDM_DAY2', column: '1', colSpan: 4 },
      { title: 'Day3', tlabel: 'MDM_DAY3', column: '2', colSpan: 4 },
      { title: 'Day4', tlabel: 'MDM_DAY4', column: '3', colSpan: 4 },
      { title: 'Day5', tlabel: 'MDM_DAY5', column: '4', colSpan: 4 },
      { title: 'Day6', tlabel: 'MDM_DAY6', column: '5', colSpan: 4 },
    ],
  },
  { id: 6, title: 'Updated by', tlabel: 'MDM_UPDATED_BY', colSpan: 3, column: 'updated_by', truncateOn: 20, show: false },
  { id: 7, title: 'Updated Date', tlabel: 'MDM_UPDATED_DATE', colSpan: 3, column: 'updated_at', truncateOn: 20, show: false },

];


const material = [
  { id: 0, title: 'Code', column: 'code', tlabel: 'MDM_CODE', show: true, colSpan: 3, truncateOn: 13 },
  { id: 1, title: 'Name', column: 'name', tlabel: 'MDM_NAME', show: true, colSpan: 3, truncateOn: 16 },
  { id: 2, title: 'Business Unit', column: 'business_unit', tlabel: 'MDM_BUSINESS_UNIT', show: false, colSpan: 3, truncateOn: 12 },
  { id: 3, title: 'Pce Per Box', column: 'piece_per_box', tlabel: 'MDM_PCE_PER_BOX', show: true, colSpan: 3 },
  { id: 4, title: 'Length (cm)', column: 'box_length', tlabel: 'MDM_LENGTH', show: true, colSpan: 3 },
  { id: 5, title: 'Width (cm)', column: 'box_width', tlabel: 'MDM_WIDTH', show: true, colSpan: 3 },
  { id: 6, title: 'Height (cm)', column: 'box_height', tlabel: 'MDM_HEIGHT', show: true, colSpan: 3 },
  { id: 7, title: 'Weight (kg)', column: 'box_weight', tlabel: 'MDM_WEIGHT', show: true, colSpan: 3 },
  { id: 7.1, title: 'Gross Weight (kg)', column: 'gross_weight', tlabel: 'MDM_GROSS_WEIGHT', show: true, colSpan: 3, feature: 'gross_weight_support' },
  { id: 8, title: 'Volume (cft)', column: 'box_volume', tlabel: 'MDM_VOLUME', show: false, colSpan: 3 },
  { id: 9, title: 'Volume Per Piece', column: 'volume_per_piece', tlabel: 'MDM_VOLUME_PER_PIECE', show: false, colSpan: 3 },
  { id: 10, title: 'Category', column: 'category', tlabel: 'MDM_CATEGORY', show: true, colSpan: 3 },
  { id: 11, title: 'Associated', column: 'associated_material_count', tlabel: 'MDM_ASSOCIATED', show: false, colSpan: 3 },
  { id: 12, title: 'Updated by', column: 'updated_by', tlabel: 'MDM_UPDATED_BY', show: false, colSpan: 3, truncateOn: 17 },
  { id: 13, title: 'Updated date', column: 'updated_at', tlabel: 'MDM_UPDATED_DATE', show: false, colSpan: 3, truncateOn: 17 },
  { id: 14, title: 'GST Exempt', column: 'gst_exempt', tlabel: 'MDM_GST_EXEMPT', show: false, colSpan: 3 },
  { id: 15, title: 'Pallets', column: 'pallets', tlabel: 'MDM_PALLETS', show: false, colSpan: 3 },
  { id: 16, title: 'Brand', column: 'brand', tlabel: 'MDM_BRAND', show: false, colSpan: 3, truncateOn: 12 },
  { id: 17, title: 'Sub Brand', column: 'sub_brand', tlabel: 'MDM_SUB_BRAND', show: false, colSpan: 3, truncateOn: 17 },
  { id: 18, title: 'Thickness', column: 'thickness', tlabel: 'MDM_THICKNESS', show: false, colSpan: 3 },
  { id: 19, title: 'Load Sequence', column: 'load_sequence', tlabel: 'MDM_LOAD_SEQUENCE', show: false, colSpan: 3 },
  { id: 20, title: 'Can Telescope', column: 'can_telescope', tlabel: 'MDM_CAN_TELESCOPE', show: false, colSpan: 3 },
];
const route_master = [
  { id: 0, title: 'Name', tlabel: 'MDM_NAME', colSpan: 3, column: 'name', truncateOn: 22, show: true },
  { id: 1, title: 'Source', tlabel: 'MDM_SOURCE', colSpan: 4, column: 'source', truncateOn: 20, show: true },
  { id: 2, title: 'Destination', tlabel: 'MDM_DESTINATION', colSpan: 4, column: 'destination', truncateOn: 20, show: true },
  { id: 3, title: 'Depot Setting', tlabel: 'MDM_DEPOT_SETTING', colSpan: 2, column: 'depot_settings', truncateOn: 12, show: true },
  { id: 4, title: 'Status', tlabel: 'MDM_STATUS', colSpan: 3, column: 'status', show: true },
  { id: 5, title: 'Updated By', tlabel: 'MDM_UPDATED_BY', colSpan: 3, column: 'updated_by', truncateOn: 22, show: true },
];

const transshipment = [
  { id: 0, title: 'Source | Gate ID', tlabel: 'MDM_SOURCE_GATE_ID', colSpan: 3, column: 'source', truncateOn: 22, show: true },
  { id: 1, title: 'Hub Type', tlabel: 'MDM_HUB_TYPE', colSpan: 3, column: 'hubType', truncateOn: 20, show: true },
  { id: 2, title: 'Hubs | Hub Ref Ids', tlabel: 'MDM_HUBS', colSpan: 6, column: 'hub', truncateOn: 20, show: true },
  { id: 4, title: 'Status', tlabel: 'MDM_STATUS', colSpan: 3, column: 'status', show: true },
];
const source_charge = [
  { id: 0, label: 'Source Type', tlabel: 'MDM_SOURCE_CHARGE_SOURCE_TYPE', colSpan: 3, column: 'source_type', truncateOn: 22, show: true },
  { id: 1, label: 'Source', tlabel: 'MDM_SOURCE_CHARGE_SOURCE', colSpan: 3, column: 'source', truncateOn: 22, show: true },
  { id: 2, label: 'Movement', tlabel: 'MDM_SOURCE_CHARGE_MOVEMENT', colSpan: 3, column: 'movement', truncateOn: 22, show: true },
  { id: 3, label: 'Transporter Ref Id', tlabel: 'MDM_SOURCE_CHARGE_TRANSPORTER_REF_ID', colSpan: 3, column: 'transporter_ref_id', truncateOn: 22, show: true },
  { id: 4, label: 'Vehicle Type', tlabel: 'MDM_SOURCE_CHARGE_VEHICLE_TYPE', colSpan: 3, column: 'vehicle_type', truncateOn: 22, show: true },
  { id: 5, label: 'Charge Code', tlabel: 'MDM_SOURCE_CHARGE_CODE', colSpan: 3, column: 'charge_code', truncateOn: 22, show: true },
];

const transit_management = [
  { id: 0, title: 'Type', column: 'type', tlabel: 'MDM_TYPE', truncateOn: 25, show: true, colSpan: 3, type: 'text' },
  { id: 1, title: 'Source', column: 'source', tlabel: 'MDM_SOURCE', truncateOn: 20, show: true, colSpan: 3, type: 'text' },
  { id: 2, title: 'Destination', column: 'destination', tlabel: 'MDM_DESTINATION', truncateOn: 20, show: true, colSpan: 3, type: 'text' },
  { id: 3, title: 'Transporter Name', column: 'transporter_name', tlabel: 'MDM_TRANSPORTER_NAME', truncateOn: 20, show: true, colSpan: 3, type: 'text' },
  { id: 4, title: 'Transporter Ref ID', column: 'transporter_refid', tlabel: 'MDM_TRANSPORTER_REF_ID', truncateOn: 20, show: true, colSpan: 3, type: 'text' },
  { id: 5, title: 'Vehicle Name', column: 'vehicle_code', tlabel: 'MDM_VEHICLE_NAME', truncateOn: 25, show: true, colSpan: 3, type: 'text' },
  { id: 6, title: 'Transit Days', column: 'transit_days', tlabel: 'MDM_TRANSIT_DAYS', show: true, colSpan: 3, type: 'text' },
];
const bucc = [
  {
    title: 'Code',
    column: 'code',
    tlabel: 'MDM_CODE',
    truncateOn: 15,
    colSpan: 3,
  },
  {
    title: 'Description',
    column: 'description',
    tlabel: 'MDM_DESCRIPTION',
    truncateOn: 20,
    colSpan: 4,
  },
  {
    title: 'Sector',
    column: 'sector',
    tlabel: 'MDM_SECTOR',
    colSpan: 3,
  },
  {
    title: 'Center',
    column: 'center',
    tlabel: 'MDM_CENTER',
    truncateOn: 15,
    colSpan: 3,
  },
  {
    title: 'Updated by',
    column: 'updated_by',
    tlabel: 'MDM_UPDATED_BY',
    truncateOn: 17,
    colSpan: 3,
  },
  {
    title: 'Updated date',
    column: 'updated_at',
    tlabel: 'MDM_UPDATED_DATE',
    truncateOn: 17,
    colSpan: 3,
  }];

const purchase_order = [
  {
    id: 0,
    title: 'PO Number',
    column: 'po_number',
    tlabel: 'MDM_PO_NUMBER',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 1,
    title: 'PO Line Item Number',
    column: 'po_line_number',
    tlabel: 'MDM_PO_LINE_ITEM_NUMBER',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 2,
    title: 'Account Assignment Number',
    column: 'account_assignment_number',
    tlabel: 'MDM_ACCOUNT_ASSIGNMENT_NUMBER',
    truncateOn: 15,
    colSpan: 4,
    show: true,
  },
  {
    id: 3,
    title: 'Net Value',
    column: 'po_net_value',
    tlabel: 'MDM_NET_VALUE',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 4,
    title: 'Transporter',
    column: 'transporter_name',
    tlabel: 'MDM_TRANSPORTER',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 5,
    title: 'Transporter Ref Id',
    column: 'transporter_reference_id',
    tlabel: 'MDM_PO_TRANSPORTER_REF_ID',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 6,
    title: 'Balance Value',
    column: 'po_balance_value',
    tlabel: 'MDM_BALANCE_VALUE',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 7,
    title: 'Status',
    column: 'status',
    tlabel: 'MDM_PO_STATUS',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 8,
    title: 'Updated By',
    column: 'updated_by',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 8,
    title: 'Uploaded By',
    column: 'uploaded_by',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
];

const materialcategory = [
  {
    id: 0,
    title: 'Name',
    column: 'name',
    tlabel: 'MDM_NAME',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 1,
    title: 'Cluster',
    column: 'cluster',
    tlabel: 'MDM_CLUSTER',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 2,
    title: 'Stacking Norms',
    column: 'stacking_norms',
    tlabel: 'MDM_STACKING_NORMS',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 3,
    title: 'Positioning Constraints',
    column: 'positioning_constraints',
    tlabel: 'MDM_POSITIONING_CONSTRAINTS',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 4,
    title: 'Shortage Unit',
    column: 'shortage_unit',
    tlabel: 'MDM_SHOAGE_UNIT',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 5,
    title: 'Damage Unit',
    column: 'damage_unit',
    tlabel: 'MDM_DAMAGE_UNIT',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 6,
    title: 'Carton Damage Unit',
    column: 'carton_damage_unit',
    tlabel: 'MDM_CARTON_DAMAGE_UNIT',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 7,
    title: 'Carton Damage Type',
    column: 'carton_damage_type',
    tlabel: 'MDM_CARTON_DAMAGE_TYPE',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 8,
    title: 'Carton Damage Factor',
    column: 'carton_damage_factor',
    tlabel: 'MDM_CARTON_DAMAGE_FACTOR',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 9,
    title: 'GST Exempt',
    column: 'gstExempt',
    tlabel: 'MDM_GST_EXEMPT',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 10,
    title: 'Shortage Tolerance',
    column: 'shortage_tolerance',
    tlabel: 'MDM_SHORTAGE_TOLERANCE',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 11,
    title: 'Damage Tolerance',
    column: 'damage_tolerance',
    tlabel: 'MDM_DAMAGE_TOLERANCE',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 12,
    title: 'Optima Floor2',
    column: 'optima_floor2',
    tlabel: 'MDM_OPTIMA_FLOOR2',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 13,
    title: 'Optima Group',
    column: 'optima_group',
    tlabel: 'MDM_OPTIMA_GROUP',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 14,
    title: 'Max Utilization',
    column: 'max_utilization',
    tlabel: 'MDM_MAX_UTILIZATION',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 15,
    title: 'Excluded Material Categories',
    column: 'excluded_material_categories_list',
    tlabel: 'MDM_EXCLUDED_MATERIAL_CATEGORIES',
    truncateOn: 15,
    colSpan: 3,
    show: true,
  },
  {
    id: 16,
    title: 'Shortage Type',
    column: 'shortage_type',
    tlabel: 'MDM_SHORTAGE_TYPE',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 17,
    title: 'Shortage Factor',
    column: 'shortage_factor',
    tlabel: 'MDM_SHORTAGE_FACTOR',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 18,
    title: 'Damage Type',
    column: 'damage_type',
    tlabel: 'MDM_DAMAGE_TYPE',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 19,
    title: 'Damage Factor',
    column: 'damage_factor',
    tlabel: 'MDM_DAMAGE_FACTOR',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  }, {
    id: 20,
    title: 'Budget Percentage',
    column: 'budget_percentage',
    tlabel: 'MDM_BUDGET_PERCENTAGE',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 21,
    title: 'Updated by',
    column: 'updated_by',
    tlabel: 'MDM_UPDATED_BY',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
  {
    id: 22,
    title: 'Updated date',
    column: 'updated_at',
    tlabel: 'MDM_UPDATED_AT',
    truncateOn: 15,
    colSpan: 3,
    show: false,
  },
];

const redirection = [
  { id: 0, title: 'source depot name', column: 'source_depot_name', tlabel: 'SOURCE_DEPOT_NAME', truncateOn: 30, show: true, colSpan: 2, is_searchable: true },
  { id: 1, title: 'redirection depot name', column: 'redirection_depot_name', tlabel: 'REDIRECTION_DEPOT_NAME', truncateOn: 30, show: true, colSpan: 3 },
  { id: 2, title: 'redirection depot gate', column: 'gate_name', tlabel: 'REDIRECTION_DEPOT_GATE', truncateOn: 30, show: true, colSpan: 3 },
  { id: 3, title: 'order type', column: 'order_type', tlabel: 'ORDER_TYPE', truncateOn: 30, show: true, colSpan: 3 },
  { id: 4, title: 'associated material category', column: 'associated_categories', tlabel: 'ASSOCIATED_MATERIAL_CATEGORY', truncateOn: 30, show: true, colSpan: 3 },
  { id: 5, title: 'associated state/city', column: 'associated_locations', tlabel: 'ASSOCIATED_STATE_CITY', truncateOn: 30, show: true, colSpan: 3 },
];

const freight_zone = [
  { id: 0, title: 'Name', column: 'name', tlabel: 'MDM_NAME', truncateOn: 30, show: true, colSpan: 5 },
  { id: 1, title: 'Pincodes', column: 'pincodes', tlabel: 'MDM_PINCODES', wordTruncateOn: 26, show: true, type: 'list', configCheck: config => !config.freight_zone_level || config.freight_zone_level === freightZoneLevel.CLIENT },
  { id: 2, title: 'Transporter', column: 'transporter_name', tlabel: 'WALLET_TRANSPORTER', colSpan: 5, truncateOn: 30, configCheck: config => config.freight_zone_level === freightZoneLevel.TRANSPORTER, show: true },
  { id: 3, title: 'Type', column: 'zone_type', tlabel: 'MDM_TYPE', truncateOn: 30, show: true, configCheck: config => config.freight_zone_level === freightZoneLevel.TRANSPORTER, colSpan: 5 },
  { id: 4, title: 'Locations', column: 'locations', tlabel: 'ZONE_LOCATIONS', wordTruncateOn: 26, show: true, configCheck: config => config.freight_zone_level === freightZoneLevel.TRANSPORTER, type: 'list' },
];

const legal_entity = [
  { id: 0, title: 'Legal Entity Code', column: 'legal_entity_code', tlabel: 'LEGAL_ENTITY_CODE', truncateOn: 30, show: true, colSpan: 3 },
  { id: 1, title: 'Company Name', column: 'company_name', tlabel: 'FREIGHT_INVOICE_COMPANY_NAME', truncateOn: 30, show: true, colSpan: 3 },
  { id: 2, title: 'Company GSTIN', column: 'gstin', tlabel: 'FREIGHT_INVOICE_COMPANY_GSTIN', truncateOn: 30, show: true, colSpan: 3 },
  { id: 3, title: 'Company Address', column: 'address', tlabel: 'FREIGHT_INVOICE_COMPANY_ADDRESS', truncateOn: 30, show: true, colSpan: 3 },
  { id: 4, title: 'Company City', column: 'city', tlabel: 'FREIGHT_INVOICE_COMPANY_CITY', truncateOn: 30, show: true, colSpan: 3 },
  { id: 5, title: 'Company State', column: 'state', tlabel: 'FREIGHT_INVOICE_COMPANY_STATE', truncateOn: 30, show: true, colSpan: 3 },
  { id: 6, title: 'Company Pincode', column: 'pincode', tlabel: 'FREIGHT_INVOICE_COMPANY_PINCODE', truncateOn: 30, show: true, colSpan: 3 },
  { id: 7, title: 'LR Document Company Name', column: 'lr_document_company_name', tlabel: 'LR_DOCUMENT_COMPANY_NAME', truncateOn: 30, show: false, colSpan: 3 },
  { id: 8, title: 'LR Document Company GSTIN', column: 'lr_document_company_gstin', tlabel: 'LR_DOCUMENT_COMPANY_GSTIN', truncateOn: 30, show: false, colSpan: 3 },
  { id: 9, title: 'LR Document Company Address', column: 'lr_document_company_address', tlabel: 'LR_DOCUMENT_COMPANY_ADDRESS', truncateOn: 30, show: false, colSpan: 3 },
  { id: 10, title: 'LR Document Company City', column: 'lr_document_company_city', tlabel: 'LR_DOCUMENT_COMPANY_CITY', truncateOn: 30, show: false, colSpan: 3 },
  { id: 11, title: 'LR Document Company State', column: 'lr_document_company_state', tlabel: 'LR_DOCUMENT_COMPANY_STATE', truncateOn: 30, show: false, colSpan: 3 },
  { id: 12, title: 'LR Document Company Pincode', column: 'lr_document_company_pincode', tlabel: 'LR_DOCUMENT_COMPANY_PINCODE', truncateOn: 30, show: false, colSpan: 3 },
];

const vehicle = [
  {
    id: 0,
    title: 'Name',
    column: 'short_form',
    tlabel: 'MDM_NAME',
    truncateOn: 15,
    show: true,
    colSpan: 3,
  },
  {
    id: 1,
    title: 'CFT',
    column: 'cft',
    tlabel: 'MDM_CFT',
    show: true,
    colSpan: 3,
  },
  {
    id: 2,
    title: 'KG',
    column: 'kg',
    tlabel: 'MDM_KG',
    show: true,
    colSpan: 3,
  },
  {
    id: 3,
    title: 'Vehicle Type',
    column: 'vehicle_type',
    tlabel: 'Vehicle Type',
    show: true,
    colSpan: 3,
  },
  {
    id: 4,
    title: 'Vehicle Weightage',
    column: 'weightage',
    tlabel: 'Vehicle Weightage',
    show: true,
    colSpan: 3,
  },
  {
    id: 5,
    title: 'Length',
    column: 'length',
    tlabel: 'MDM_LENGTH',
    show: false,
    colSpan: 3,
  },
  {
    id: 6,
    title: 'Breadth',
    column: 'breadth',
    tlabel: 'MDM_BREADTH',
    show: false,
    colSpan: 3,
  },
  {
    id: 7,
    title: 'Height',
    column: 'height',
    tlabel: 'MDM_HEIGHT',
    show: false,
    colSpan: 3,
  },
  {
    id: 8,
    title: 'Description',
    column: 'description',
    tlabel: 'MDM_DESCRIPTION',
    show: false,
    truncateOn: 15,
    colSpan: 3,
  },
  {
    id: 9,
    title: 'Max distance',
    column: 'max_distance',
    tlabel: 'MDM_MAX_DISTANCE',
    show: false,
    colSpan: 3,
  },
  {
    id: 10,
    title: 'Mode',
    column: 'mode',
    tlabel: 'VEHICLE_TYPE_MODE',
    show: false,
    colSpan: 3,
  },
  {
    id: 11,
    title: 'Updated by',
    column: 'updated_by',
    tlabel: 'MDM_UPDATED_BY',
    truncateOn: 17,
    show: false,
    colSpan: 3,
  },
  {
    id: 12,
    title: 'Updated date',
    column: 'updated_at',
    tlabel: 'MDM_UPDATED_DATE',
    truncateOn: 17,
    show: false,
    colSpan: 3,
  },
  {
    id: 13,
    title: 'Fuel type',
    column: 'fuel_type',
    tlabel: 'MDM_FUEL_TYPE',
    show: true,
    colSpan: 3,
  },
  {
    id: 14,
    title: 'Carbon Emission Factor',
    column: 'carbon_emission_factor',
    tlabel: 'MDM_CARBON_EMISSION_FACTOR',
    show: false,
    colSpan: 3,
  },
  {
    id: 15,
    title: 'Excluded Categories',
    column: 'exclude_sku_categories',
    tlabel: 'MDM_EXCLUDED_MATERIAL_CATEGORIES',
    show: false,
    colSpan: 3,
  },
];

const ndc_master = [
  { id: 0, title: 'Quarter', colSpan: 2, column: 'quarter_name', show: true },
  { id: 1, title: 'Clear NDC', colSpan: 2, column: 'cndc_label', show: true },
  { id: 2, title: 'NDC with Outstanding', colSpan: 3, column: 'ondc_label', show: true },
  { id: 3, title: 'Transporter Name', colSpan: 3, column: 'transporter_name', show: true },
  { id: 4, title: 'Ref ID', colSpan: 2, column: 'transporter_reference_id', show: true },
  { id: 5, title: 'Updated By', colSpan: 3, column: 'updated_by_type', show: true, truncateOn: 20 },
  { id: 6, title: 'Updated Date', colSpan: 2, column: 'updated_date', show: true, truncateOn: 12 },
];


export const listHeaders = {
  port,
  cha,
  container,
  freightforwarder,
  carton,
  carrier,
  shipmethod,
  transportationdb,
  transporter,
  billdiscount,
  contract,
  vehicledetail,
  consignee,
  contracttsd,
  destination_charge,
  user,
  package_master,
  material_package_map,
  depot,
  sla,
  detention,
  approval,
  material,
  route_master,
  bfr,
  transshipment,
  bucc,
  purchase_order,
  source_charge,
  transit_management,
  materialcategory,
  redirection,
  freight_zone,
  legal_entity,
  vehicle,
  ndc_master,
};
